import React from 'react';

import { Box } from '@chakra-ui/react';
import {
  Dropdown,
  DropdownChip,
  DropdownContent,
  DropdownRadioGroup,
  DropdownRadioItem,
  DropdownTrigger,
} from '@mesh.ai/rabbit';
import { useDispatch } from 'react-redux';
import {
  ONE_ON_ONE_INSIGHTS_GROUP_BY_KEYS,
  setGroupByKeysOneOnOneInsightsFilters,
  useOneOnOneInsightsFiltersData,
} from 'screens/oneOnOneRabbit/Insights/slice/OneOnOneInsightsFiltersSlice';

import { sendSelectedGroupByEvent } from 'constants/mixpanelHelper';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const OneOnOneGroupBy = () => {
  const dispatch = useDispatch();

  const { groupByKeys: selectedGroupBy } = useOneOnOneInsightsFiltersData();

  const onChangeHandler = ({ value }) => {
    sendSelectedGroupByEvent({
      eventProperties: {
        source: '1:1s',
        type: value?.displayName,
      },
    });
    dispatch(
      setGroupByKeysOneOnOneInsightsFilters({
        groupByKeys: value,
      })
    );
  };

  return (
    <Dropdown>
      <DropdownTrigger asChild>
        <DropdownChip className="chip-dropdown">
          <TextBodyMedium bold color="text.g2" className="group-data[state=open]:text-[#004F67]">
            Group by:
          </TextBodyMedium>
          <Box display="inline-flex" alignItems="center" justifyContent="center" gap="4px">
            <TextBodyMedium bold color="text.g1">
              {selectedGroupBy?.displayName}
            </TextBodyMedium>
          </Box>
        </DropdownChip>
      </DropdownTrigger>
      <DropdownContent align="start" style={{ minWidth: '200px' }}>
        <DropdownRadioGroup value={selectedGroupBy?.keyName}>
          {ONE_ON_ONE_INSIGHTS_GROUP_BY_KEYS?.map(({ value }) => (
            <DropdownRadioItem key={value.keyName} value={value.keyName} onClick={() => onChangeHandler({ value })}>
              {value.displayName}
            </DropdownRadioItem>
          ))}
        </DropdownRadioGroup>
      </DropdownContent>
    </Dropdown>
  );
};

export { OneOnOneGroupBy };
